import * as React from 'react'

const BlankGroupNode: React.FunctionComponent = () => null

export default BlankGroupNode
